import {PopupRequest, RedirectRequest} from '@azure/msal-browser'

export const b2cPolicies = {
  names: {
    signUpSignIn: process.env.REACT_APP_NAMES_SIGNUP_SIGNIN,
  },

  authorities: {
    signUpSignIn: {
      authority: process.env.REACT_APP_AUTHORITY_BASE_URL + '/' + process.env.REACT_APP_NAMES_SIGNUP_SIGNIN,
    } as RedirectRequest,
  },
  authorityDomain: process.env.REACT_APP_AUTHORITY_DOMAIN,
}

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    authority: process.env.REACT_APP_AUTHORITY_BASE_URL + '/' + process.env.REACT_APP_NAMES_SIGNUP_SIGNIN,
    knownAuthorities: [
      process.env.REACT_APP_AUTHORITY_DOMAIN || '',
      process.env.REACT_APP_AUTHORITY_BASE_URL + '/' + process.env.REACT_APP_NAMES_SIGNUP_SIGNIN,
    ],
    redirectUri: process.env.REACT_APP_REDIRECT_URL,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
}

export const loginRequest: PopupRequest = {
  scopes: ['openid'],
}

export const silentRequest = {
  scopes: [
    'openid',
    'offline_access',
    `${process.env.REACT_APP_SILENT_REQUEST_BASE}/api.read`,
    `${process.env.REACT_APP_SILENT_REQUEST_BASE}/user.read.all`,
    `${process.env.REACT_APP_SILENT_REQUEST_BASE}/user.roles`,
    `${process.env.REACT_APP_SILENT_REQUEST_BASE}/admin.roles.manage`,
  ],
  forceRefresh: true,
  loginHint: 'skfsso-test.skf.com', //uncomment ths for test
}

export const adobeConfig = {
  loginUrl: `${process.env.REACT_APP_ADOBE_LOGIN}`,
}
